import { apiSlice } from "api/api.slice";
import type { CallToActionResponse } from "api/api.types";
import { callToActionResponseSchema } from "api/schemas/callToActionApiSchema";
import { toSearchString } from "api/utils";

export type CallToActionArg = { topic_id?: string };

export const callToActionApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    callToAction: build.query<CallToActionResponse, CallToActionArg>({
      providesTags: (_result, _error, arg) => [{ type: "CallToAction" as const, id: arg.topic_id }],
      query: ({ topic_id }) => ({
        url: `/call_to_action${toSearchString({ topic_id })}`,
        schema: callToActionResponseSchema,
      }),
    }),
  }),
});
